import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import Table from '../../../components/Table';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/pt';
import DateFnsUtils from '@date-io/date-fns';
import deLocale from 'date-fns/locale/pt-BR';
import { useDispatch } from 'react-redux';
import { TextField } from '@mui/material';

function WaterInputs() {
  const [waterInputs, setWaterInputs] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const dispatch = useDispatch();
  const [locale, setLocale] = React.useState('pt');

  const columns = [
    {
      title: 'Viveiro',
      field: 'cycle.pond.description',
      hideFilterIcon: true,
    },
    {
      title: 'Ciclo',
      field: 'cycle.description',
      hideFilterIcon: true,
      editable: 'never',
    },
    {
      title: 'Quantidade ',
      field: 'quantity',
      hideFilterIcon: true,
      render: (rowData) => (
        <span>{new Intl.NumberFormat('pt-BR').format(rowData.quantity)}</span>
      ),
    },
    {
      title: 'Data/Hora da medição',
      field: 'date',
      type: 'datetime',
      hideFilterIcon: true,
      dateSetting: { locale: 'pt-BR' },
      editComponent: (props) => (
        <LocalizationProvider adapterLocale={deLocale} dateAdapter={DateFnsUtils}>
          <DateTimePicker
            format="dd/MM/yyyy HH:mm:ss"
            value={props.value}
            onChange={props.onChange}
            InputProps={{
              style: {
                fontSize: 13,
              },
            }}
            fullWidth
                        // inputFormat="DD/MM/YYYY HH:mm:ss"
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      ),
    },
    {
      title: 'Tipo de Entrada',
      field: 'waterSource.name',
      hideFilterIcon: true,
    },

  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/water-inputs');

        if (response.data.length === 0) {
          dispatch(setOpenProgress(true));
        }
        if (response.data) {
          setWaterInputs(response.data);
          dispatch(setOpenProgress(true));
        }
      } catch (err) {

      }
    }
    loadData();
  }, [dispatch]);

  function setData(newData) {
    const tempData = [];
    waterInputs.map((waterInput) => (
      waterInput.id === newData.id ? tempData.push(newData) : tempData.push(waterInput)
    ));
    setWaterInputs(tempData);
  }
  return (
    <Table title="Consumo de Água" route="/water-inputs/" routeAdd="/water-input/" columns={columns} data={waterInputs} setData={setData} dataLoaded={openProgress} />
  );
}

export default WaterInputs;
